import { render, staticRenderFns } from "./IndagineEpidemioogicaTubercolosiMicobatteriosiNonTubercolariViewComponent.vue?vue&type=template&id=95deeb9e"
import script from "./IndagineEpidemioogicaTubercolosiMicobatteriosiNonTubercolariViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemioogicaTubercolosiMicobatteriosiNonTubercolariViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports